import Cookies from 'js-cookie'

const TokenKey = 'file-token'
const TokenKeyTwo = 'user-name'

// token
export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}

// username
export function getUserName() {
  return Cookies.get(TokenKeyTwo)
}
export function setUserName(token) {
  return Cookies.set(TokenKeyTwo, token)
}
export function removeUserName() {
  return Cookies.remove(TokenKeyTwo)
}
